import { toAbsoluteFotoUrl } from './foto-url';

/**
 * Busca uma imagem (ex.: pictograma) na sua resolução/qualidade ORIGINAL e a
 * devolve como data URL base64, preservando os bytes originais (sem recodificar).
 *
 * Usado ao inserir pictogramas: assim eles entram pelo mesmo caminho comprovado
 * das fotos coladas (base64 → arquivo no salvar) e o backend consegue embuti-los
 * no PDF. A URL crua /api/pictogramas/... não serve para isso — ela não é baixada
 * na geração do PDF (o processador só trata /uploads/ e http), o que deixaria o
 * pictograma ausente/quebrado.
 */
export async function imagemParaDataUrl(fotoUrl: string): Promise<string> {
  const resp = await fetch(toAbsoluteFotoUrl(fotoUrl));
  if (!resp.ok) throw new Error(`Falha ao carregar imagem (${resp.status})`);
  const blob = await resp.blob();
  return await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('Falha ao ler imagem'));
    reader.readAsDataURL(blob);
  });
}
